<template>
  <div>
    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        persistent
        :max-width="dialogMaxWidth"
        id="cvdialogall"
        :content-class="contentClass"
        :fullscreen="fullScreen"
        :hide-overlay="hideOverlay"
        :transition="transitionType"
      >
        <v-card class="dialog-inner">
          <v-card-title v-if="!showCVPopup" class>
            <v-flex>
              <h3 class="display-24">התחברות/הרשמה</h3>
            </v-flex>
            <v-flex class="text-left x-close">
              <v-btn color="primary large" text @click="handleCloseDialog">
                <v-icon class="icon-forma-1-2 display-16" />
              </v-btn>
            </v-flex>
            <DropDivider :width="'100%'" />
          </v-card-title>

          <v-card-text v-if="!showCVPopup">
            <v-container grid-list-md pt-0 pl-0 pr-0>
              <v-layout wrap justify-center>
                <v-btn
                  outlined
                  large
                  class="looking-btn display-16"
                  :class="{ 'selected-looking': showLogin }"
                  @click="
                    showLogin = !showLogin;
                    showRegister = false;
                  "
                >
                  משתמש רשום
                </v-btn>

                <v-btn
                  outlined
                  large
                  class="recruiter-btn display-16"
                  :class="{ 'selected-recruiter': showRegister }"
                  @click="
                    showRegister = !showRegister;
                    showLogin = false;
                  "
                >
                  משתמש חדש
                </v-btn>
              </v-layout>

              <v-layout wrap justify-center>
                <v-flex v-show="showLogin" xs12>
                  <FormLogin
                    @showCVForm="displayCVPopup"
                    :emitToCVPopup="true"
                  />
                </v-flex>

                <v-flex v-show="showRegister">
                  <SignUpForm
                    :redirect-back="false"
                    @showCVForm="displayCVPopup"
                    @moveToLogin="handleRedirectExistingUser"
                    :page="'4'"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-flex v-if="showCVPopup && isLogged" class="d-flex" height="100%">
            <CVPopupAll :jobs-details="jobsToSend" />
          </v-flex>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import SignUpForm from '@/components/Forms/SignUpForm.vue';
import FormLogin from '@/components/NavigationMenu/UserMenu/FormLogin.vue';
import CVPopupAll from '@/components/Dialogs/CvsJobBasket/CVPopupAll';
import DropDivider from '@/components/DropDownMenu/DropDivider';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  mixins: [CurrentUser],
  components: {
    SignUpForm,
    FormLogin,
    CVPopupAll,
    DropDivider,
  },
  scrollToTop: false,
  props: {
    openDialog: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    jobsToSend: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      showLogin: true, // temp
      showRegister: false,
      showCVPopup: true,
      fullScreen: false,
      hideOverlay: false,
      transitionType: false,
      contentClass: 'border-radius-20',
      dialogMaxWidth: null,
    };
  },

  computed: {
    user() {
      return this.CurrentUser;
    },
  },

  watch: {
    openDialog() {
      this.dialog = this.openDialog;
    },
    dialog(val) {
      if (val === false) this.$bus.$emit('closeDialog', false);
    },
  },

  created() {
    this.dialog = this.openDialog;
  },

  mounted() {
    this.$nuxt.$on('jobsToSendCv', this.displayCVPopup);

    this.$nuxt.$on('closeBasketDialog', this.handleCloseDialog);

    this.dialogMobile();
  },

  beforeDestroy() {
    this.showLogin = false;
    this.showRegister = false;
    this.showCVPopup = false;
    this.dialog = false;
    this.$nuxt.$off('jobsToSendCv');

    this.$nuxt.$off('closeBasketDialog');
  },

  methods: {
    /**
     * @dialogMobile Adjust CV diaolg on mobile props on mounted.
     * Will display dialog on fullscreen
     */
    dialogMobile() {
      if (window.innerWidth < 600) {
        this.fullScreen = true;
        this.hideOverlay = false;
        this.transitionType = 'dialog-bottom-transition';
        this.contentClass = 'cvdialogall';
      }
    },

    displayCVPopup() {
      this.showLogin = false;
      this.showRegister = false;
      this.dialog = true;
      this.showCVPopup = true;
    },
    updateSend(confirmaitionDetails) {
      this.$nuxt.$emit('updateSendInfo', confirmaitionDetails);
    },

    handleConfirmSend(confirmaitionDetails) {
      this.$nuxt.$emit('openConfirmPopup');
      setTimeout(() => {
        this.updateSend(confirmaitionDetails);
      }, 3000);
    },

    handleCloseDialog() {
      this.dialog = !this.dialog;
    },

    /**
     * method is responsible to display the login instead of register for existing user and to pass the email to thecorresponding field
     * @email { String } the users Email
     *
     */
    handleRedirectExistingUser(email) {
      this.showRegister = false;
      this.showLogin = true;
      this.$bus.$emit('existingEmailToLogin', email);
    },
  },
};
</script>

<style lang="scss" scoped>
.cv-dialog {
  border-radius: 100px;
}

.dialog-inner {
  padding: 0;
}

.looking-btn,
.recruiter-btn {
  border-radius: 5px;
  padding: 3px 5px;
  width: 100px;
  border-color: #f6f7f9;
}

.looking-btn.selected-looking {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.recruiter-btn.selected-recruiter {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.looking-btn.selected-looking:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.recruiter-btn.selected-recruiter:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.password-recover {
  text-align: left;
  transform: translateY(-25px);
  color: #000;
}

@media only screen and (min-width: 600px) {
  .dialog-inner {
    padding: 16px;
  }

  .looking-btn,
  .recruiter-btn {
    border-radius: 5px;
    padding: 10px 25px;
    width: 140px;
    border-color: #f6f7f9;
  }
}
</style>
